import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const isValidValue = (value) => {
  return typeof value === 'string' && value.trim() !== '' && value.trim() !== 'undefined' && value.trim() !== 'null';
};

const isValidClientId = (value) => {
  return isValidValue(value) && /^\d+$/.test(value.trim());
};

const redirectToLogin = () => {
  localStorage.removeItem('token');
  window.location.replace(process.env.REACT_APP_LINK_URL);
};

const withAuth = (WrappedComponent) => {
  const AuthHOC = (props) => {
    const { clientId } = useParams();
    const location = useLocation();
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const urlToken = searchParams.get('token');
      const storedToken = localStorage.getItem('token');
      const routeClientId = clientId;

      const validUrlToken = isValidValue(urlToken) ? urlToken.trim() : '';
      const validStoredToken = isValidValue(storedToken) ? storedToken.trim() : '';
      const validRouteClientId = isValidClientId(routeClientId) ? routeClientId.trim() : '';

      if (validUrlToken) {
        localStorage.setItem('token', validUrlToken);
      }

      if (!validRouteClientId || (!validUrlToken && !validStoredToken)) {
        setIsAuthorized(false);
        redirectToLogin();
        return;
      }

      setIsAuthorized(true);
    }, [clientId, location.search]);

    if (!isAuthorized) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  return AuthHOC;
};

export default withAuth;
